import React from 'react';
export function ScheduleHero() {
  return <section className="bg-ink py-20 text-center px-4" data-id="element-2957">
      <h1 className="text-5xl md:text-6xl text-white mb-6" data-id="element-2958">Class Schedule</h1>
      <p className="text-xl text-gray-warm max-w-2xl mx-auto" data-id="element-2959">
        Classes available Monday through Saturday for all ages and experience
        levels.
      </p>
    </section>;
}